module.exports = __webpack_public_path__ + "static/media/audio-description.e173fa9a.svg";